import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Group,
  Center,
  Select,
  Button,
  Pagination,
  Checkbox,
  Modal,
  TextInput,
  Tabs, 
  Divider,
  Paper,
  Grid,
  Stack,
  NumberInput,
  Box,
  Skeleton,
  Breadcrumbs, 
  Anchor,
  MultiSelect,
  FileButton,
  SimpleGrid,
  Image,
  ActionIcon,
  Code,
  Loader,
} from "@mantine/core";
import {
  IconPhoto,
  IconSettings,
  IconPhotoCancel,
  IconPhotoPlus,
  IconCircleXFilled,
  IconPhotoX,
  IconX,
  IconPlus,
  IconMinus,
} from "@tabler/icons-react";
import { Dropzone } from "@mantine/dropzone";
import classes from "./StoreItemEdit.module.css";
import { showErrorAlert, showSuccessAlert } from "../../helper/alerts";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import Header from "../static/Header";
import { useQuery, useMutation, useQueryClient  } from 'react-query';
import { useForm } from '@mantine/form';
import { Link, useLocation, useParams } from "react-router-dom";

import { formatYYYY_MM_DD, formatYYYY_MM_DD_HH_mm } from "../../helper/DateTime";

export function StoreItemEdit() {
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient()
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);

    const [imgFile, setImgFile] = useState<any>(null);
    const [previewImg, setPreviewImg] = useState<string | null>(null)

    const [gallery, setGallery] = useState([])
    const [galleryTemp, setGalleryTemp] = useState([])
    const [galleryFile, setGalleryFile] = useState<File | null>(null)
    const [galleryFiles, setGalleryFiles] = useState<File[]>([])
    const [previewGallery, setPreviewGallery] = useState<any[]>([])

    const [label, setLabel] = useState("")
    const [value, setValue] = useState("")

    const [preset, setPreset] = useState<string | null>('');

    const form = useForm({
        initialValues: {

            id: 0,
            displayName: "",
            cost: 0,

            description: [],

            show: false,

            isNewArrival: false,
            isHotDeals: false,
        },

        validate: {
            displayName: (value) => (value.trim().length < 1 ? 'Please fill in the fields' : null),
            description: (value) => (value.length < 1 ? 'Please add product description' : null),
            cost: (value) => (value < 1 ? 'Invalid value' : null),
        },
    });

    useEffect(() => {
        if (!galleryFile) {
            // setPreview(null)
            return
        }

        const objectUrl = URL.createObjectURL(galleryFile)
        setGalleryFiles((prev) => [...prev, galleryFile])
        setPreviewGallery((prev) => [...prev, objectUrl])

        return () => URL.revokeObjectURL(objectUrl)
    }, [galleryFile])

    useEffect(() => {
        if(preset){
            let arr = JSON.parse(preset)
            form.setFieldValue('description', arr)
        }
    }, [preset])

    const onClickRemoveImage = (index: number) => {
        const copy = [...previewGallery];
        const copy2 = [...galleryFiles]
        copy.splice(index, 1)
        copy2.splice(index, 1)
        setPreviewGallery(copy)
        setGalleryFiles(copy2)
    }

    const onClickRemoveImageTemp = (index: number) => {
        const copy = [...galleryTemp];
        copy.splice(index, 1)
        setGalleryTemp(copy)
    }

    // const uploadGallery = (locationId) => {
    //     const formData = new FormData();

    //     formData.append('locationId', locationId);

    //     [...galleryFiles].forEach((file, i) => {
    //         formData.append(`images`, file, file.name)
    //     })

    //     uploadGalleryMutation.mutate(formData)
    // }

    const getItemDescConfigQuery = useQuery(
        "getItemDescConfigQuery",
        async ({ signal }) => (await axiosPrivate.get("/api/admin/items/get-item-desc-config", { signal })).data.data,
        {
            initialData: null,
            onSuccess: (res) => {
                console.log(res)
            },
            onError: () => {

            }
        }
    );

    const getStoreItemQuery = useQuery(
        "getStoreItem",
        async ({ signal }) => (await axiosPrivate.post("/api/admin/items/get-by-id", { id }, { signal })).data.data,
        {
            initialData: null,
            onSuccess: (res) => {
                // console.log(res)
                form.setValues({...res, description: res.description ? JSON.parse(res.description) : [] })

                setGallery(JSON.parse(res.images ? res.images : '[]'))
                setGalleryTemp(JSON.parse(res.images ? res.images : '[]'))
            },
            onError: () => {

            }
        }
    );

    const updateStoreItemMutation = useMutation(
        (data: any) => {
            setIsLoading(true)
            return axiosPrivate.post("/api/admin/items/update", data, {headers: {'Content-Type': 'multipart/form-data'}})
        },
        {
            onSuccess: (res: any) => {
                queryClient.invalidateQueries({ queryKey: ['getStoreItem'] })
                setGallery([])
                setGalleryTemp([])
                setGalleryFile(null)
                setGalleryFiles([])
                setPreviewGallery([])
                setIsLoading(false);
                showSuccessAlert("Item Successfully Updated");
            },
            onError:(err: any) => {
                // setAddRebateFormVisible(false);
                setIsLoading(false);
                let errMsg = err?.response?.data?.message
                showErrorAlert(errMsg ? errMsg : 'An error has occured');
            }
        }
    );


    // const handleUpdateChanges = (data: any) => {
    //     console.log(data)

    //     // updateStoreItemMutation.mutate({
    //     //     title: data?.title,
    //     //     amount: data?.amount,
    //     //     remarks: data?.remarks,
    //     //     terms_id: data?.terms_id,
    //     //     image: imgFile ? imgFile : null,
    //     // })

    //     if(!imgFile) {
    //         console.log('Please upload image')
    //     }

    //     updateStoreItemMutation.mutate({...data, cpuChipset: data.cpuChipset.length > 0 ? JSON.stringify(data?.cpuChipset) : null})
    // };

    const handleUpdateChanges = (data: any) => {
        // console.log(data)
        const formData = new FormData();

        formData.append('id', data.id);
        formData.append('displayName', data.displayName);
        formData.append('description', JSON.stringify(data.description));
        formData.append('gallery', JSON.stringify(galleryTemp));
        formData.append('show', data.show);
        formData.append('isNewArrival', data.isNewArrival);
        formData.append('isHotDeals', data.isHotDeals);

        if(previewGallery.length > 0){
            [...galleryFiles].forEach((file, i) => {
                formData.append(`images`, file, file.name)
            })
        }
        else{
            // formData.append(`images`, null)
        }

        
        updateStoreItemMutation.mutate(formData)
    }


    useEffect(() => {
        if (!imgFile) {
            setPreviewImg(null)
            return
        }

        const objectUrl = URL.createObjectURL(imgFile)
        setPreviewImg(objectUrl)

        return () => URL.revokeObjectURL(objectUrl)
    }, [imgFile])

    const onAddDesc = () => {
        if(value.trim().length === 0 || label.trim().length === 0) {
            showErrorAlert('Please fill in the label and value');
            return
        }

        var tempArr : any = form.values.description
        let item : any  = {value: value, label: label}
        tempArr.push(item)
        form.setFieldValue('description', tempArr)

        setValue("")
        setLabel("")
    }

    const onRemoveDesc = (index: number) => {
        const copy = form.values.description
        copy.splice(index, 1)
        form.setFieldValue('description', copy)
    }


    const updateItemValue = (index: number, text: string, type: string) => {
        var updatedArr = []
        var tempArr : any = form.values.description
        if(type === 'label'){
            updatedArr = tempArr.map((item: any, i: number) =>
                i === index ? { ...item, label: text } : item
            );
        }
        if(type === 'value'){
            updatedArr = tempArr.map((item: any, i: number) =>
                i === index ? { ...item, value: text } : item
            );
        }
        
        form.setFieldValue('description', updatedArr)
    };

  return (
    <div>
        <div>
            <Header title="Store Item - Edit" />
            {isLoading && (
                <div className={classes.loadingOverlay}>
                <Loader size="xl" />
                </div>
            )}
            <Breadcrumbs mx={20} my={'sm'}>
                <Anchor component={Link} to={`/${location.pathname.split("/")[1]}`}>
                    Store Item {location.pathname.split("/")[1] === 'store-item-incomplete' ? '(Incomplete)' : null}
                </Anchor>
                <Anchor>
                    Edit
                </Anchor>
            </Breadcrumbs>
            <Box
                w={
                    window.innerWidth -
                    document.getElementById("nav-bar")!!.getBoundingClientRect().width
                }
                mt={"md"}
                
            >
                <Paper px={20}>
                    <Grid>
                        <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                            <Skeleton visible={getStoreItemQuery.isFetching || getStoreItemQuery.isError} animate={!getStoreItemQuery.isError}>
                            <form onSubmit={form.onSubmit((values) => handleUpdateChanges(values))}>
                            <Stack gap={'sm'}>
                                {/* <div>
                                    <Text fw={500} fz={15}>Image <span className={classes.format}>(.jpg, .png)</span> <span style={{color: '#F03E3E'}}>*</span></Text>
                                    <Text fw={500} fz={12} c={'#5d5d5d'}>500px x 500px</Text>
                                    <Dropzone
                                    onDrop={handleImageUpload}
                                    accept={["image/*"]}
                                    openRef={imageDropzoneRef}
                                    >
                                    <div className={classes.thumbnailContainer}>
                                        {previewImg || form.values.imageSrc ? (
                                        <img
                                            src={!previewImg ? form.values.imageSrc : previewImg}
                                            alt="Image"
                                            className={classes.thumbnailSize}
                                        />
                                        ) : (
                                        <p>
                                            <IconPhoto />
                                        </p>
                                        )}
                                    </div>
                                    </Dropzone>
                                </div> */}
                                {/* <Group>
                                {!previewImg ?
                                    <Button onClick={() => imageDropzoneRef.current?.()} leftSection={<IconPhoto />} fullWidth>Upload Image</Button>
                                : 
                                    <Button onClick={() => setImgFile(null)} leftSection={<IconPhotoCancel />} fullWidth color="gray">Remove Image</Button>
                                }
                                </Group> */}
                                <TextInput
                                    label="Display Name"
                                    placeholder="Input Display Name"
                                    withAsterisk
                                    {...form.getInputProps('displayName')}
                                />
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                <Text fw={500} fz={14}>Price</Text>
                                <Code>
                                    {
                                        getStoreItemQuery.data?.priceScheme
                                    }
                                </Code>
                                </div>
                                {/* <NumberInput
                                    label="Cost"
                                    placeholder="Input Cost"
                                    allowNegative={false}
                                    decimalScale={2}
                                    withAsterisk
                                    {...form.getInputProps('cost')}
                                /> */}
                                <div>
                                <Text fw={500} fz={14}>Show Item In Store?</Text>
                                <Checkbox
                                    defaultChecked
                                    label="Show"
                                    {...form.getInputProps('show', {type: 'checkbox'})}
                                />
                                </div>
                                <div>
                                <Text fw={500} fz={14}>New Arrival?</Text>
                                <Checkbox
                                    defaultChecked
                                    label="Yes"
                                    description="Feature item in new arrival"
                                    {...form.getInputProps('isNewArrival', {type: 'checkbox'})}
                                />
                                </div>
                                <div>
                                <Text fw={500} fz={14}>Hot Deals?</Text>
                                <Checkbox
                                    defaultChecked
                                    label="Yes"
                                    description="Feature item in hot deals"
                                    {...form.getInputProps('isHotDeals', {type: 'checkbox'})}
                                />
                                </div>
                                <Divider my="xs" label="Product Gallery" labelPosition="center" color="dark.3"/>
                                <div>
                                    <Text fw={500} fz={15}>Current Product Images <span className={classes.format}>(.jpg, .png)</span> <span style={{color: '#F03E3E'}}>*</span></Text>
                                    <SimpleGrid cols={4} spacing="xs" verticalSpacing="xs">
                                        {galleryTemp.map((item, i)=>(
                                            <div key={i} style={{position: 'relative'}}>
                                            <Image
                                                key={i}
                                                width={'100%'}
                                                height={'125'}
                                                src={item}
                                                alt="With default placeholder"
                                                // withPlaceholder
                                                fit='cover'
                                            />
                                                <UnstyledButton onClick={()=>onClickRemoveImageTemp(i)} style={{position: 'absolute', top: -10, right: -10, cursor: 'pointer'}} disabled={updateStoreItemMutation.isLoading}>
                                                    <IconCircleXFilled size={20} style={{color:"#E03131"}}/>
                                                </UnstyledButton>
                                            </div>
                                        ))}
                                        {galleryTemp.length === 0 ?
                                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',width: '100%', height: 125, backgroundColor: '#E9ECEF'}}>
                                                <IconPhotoX size={35} color={'#868E96'}/>
                                                <Text fz={12}>No image</Text>
                                            </div>
                                        : null}
                                    </SimpleGrid>
                                    { galleryTemp.length !== gallery.length ? 
                                        <Button mt={'md'} onClick={()=>setGalleryTemp(gallery)}  leftSection={<IconX size={18} />} fullWidth color='gray' disabled={updateStoreItemMutation.isLoading}>Undo Changes</Button>
                                    : null    
                                    }
                                </div>
                                <div>
                                    <Text fw={500} fz={15}>Add Product Images <span className={classes.format}>(.jpg, .png)</span> <span style={{color: '#F03E3E'}}>*</span></Text>
                                    <SimpleGrid cols={4} spacing="xs" verticalSpacing="xs">
                                        {previewGallery.map((item, i)=>(
                                            <div key={i} style={{position: 'relative'}}>
                                            <Image
                                                key={i}
                                                width={'100%'}
                                                height={'125'}
                                                src={item}
                                                alt="With default placeholder"
                                                // withPlaceholder
                                                fit='cover'
                                            />
                                                <UnstyledButton onClick={()=>onClickRemoveImage(i)} style={{position: 'absolute', top: -10, right: -10, cursor: 'pointer'}} disabled={updateStoreItemMutation.isLoading}>
                                                    <IconCircleXFilled size={20} style={{color:"#E03131"}}/>
                                                </UnstyledButton>
                                            </div>
                                        ))}
                                        {previewGallery.length < 8 ?
                                            <FileButton onChange={setGalleryFile} accept="image/png,image/jpeg" disabled={updateStoreItemMutation.isLoading}>
                                                {(props) => <UnstyledButton {...props} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',width: '100%', height: 125, cursor: 'pointer', backgroundColor: '#E9ECEF'}}>
                                                    <IconPhotoPlus size={35} color={'#868E96'}/>
                                                    <Text fz={12}>Click to add</Text>
                                                </UnstyledButton>}
                                            </FileButton>
                                        : null}
                                    </SimpleGrid>
                                </div>
                                <Divider my="xs" label="Product Description" labelPosition="center" color="dark.3"/>
                                <Select
                                    label="Description Preset"
                                    description="Select one of these presets to set the description label"
                                    placeholder="None"
                                    withAsterisk
                                    data={getItemDescConfigQuery?.data ? getItemDescConfigQuery?.data : []}
                                    disabled={updateStoreItemMutation.isLoading}
                                    value={preset}
                                    onChange={setPreset}
                                />
                                {form.values.description.length > 0 ?
                                <div>
                                <Text fw={500} fz={15}>Description <span style={{color: '#F03E3E'}}>*</span></Text>
                                <Stack gap={5}>
                                {form.values.description.map((item: any, i)=>(
                                    <div key={i} style={{display: 'flex', gap: 10, width: '100%', alignItems: 'flex-end'}}>
                                        <div style={{flex: 1}}>
                                        <TextInput
                                            placeholder="Input Label"
                                            withAsterisk
                                            value={item?.label}
                                            onChange={(event) => updateItemValue(i,event.currentTarget.value,'label')}
                                        />
                                        </div>
                                        <div style={{flex: 2}}>
                                        <TextInput
                                            placeholder="Input Value"
                                            withAsterisk
                                            value={item?.value}
                                            onChange={(event) => updateItemValue(i,event.currentTarget.value,'value')}
                                        />
                                        </div>
                                        <ActionIcon variant="filled" aria-label="Remove" size={'lg'} color="red" onClick={()=>onRemoveDesc(i)}>
                                            <IconMinus style={{ width: '70%', height: '70%' }} stroke={2} />
                                        </ActionIcon>
                                    </div>
                                ))}
                                </Stack>
                                </div>
                                : 
                                <div>
                                    <Text fw={500} fz={15}>Description <span style={{color: '#F03E3E'}}>*</span></Text>
                                    <div style={{display: 'flex', flexDirection: 'column',height: 36, backgroundColor: '#E9ECEF', justifyContent: 'center', alignItems: 'center',}}>
                                        <Text fw={600}>Please Add Label & Value</Text>
                                    </div>
                                </div>
                                }
                                <div style={{display: 'flex', gap: 10, width: '100%', alignItems: 'flex-end'}}>
                                    <div style={{flex: 1}}>
                                    <TextInput
                                        label="Label"
                                        placeholder="Input Label"
                                        withAsterisk
                                        value={label}
                                        onChange={(event) => setLabel(event.currentTarget.value)}
                                    />
                                    </div>
                                    <div style={{flex: 2}}>
                                    <TextInput
                                        label="Value"
                                        placeholder="Input Value"
                                        withAsterisk
                                        value={value}
                                        onChange={(event) => setValue(event.currentTarget.value)}
                                    />
                                    </div>
                                    <ActionIcon variant="filled" aria-label="Add" size={'lg'} color="green" onClick={onAddDesc}>
                                        <IconPlus style={{ width: '70%', height: '70%' }} stroke={2} />
                                    </ActionIcon>
                                </div>
                                <Group justify="flex-end" mt="md">
                                    <Button type="submit" loading={updateStoreItemMutation.isLoading}>Update Item</Button>
                                </Group>
                            </Stack>
                            </form>
                            </Skeleton>
                        </Grid.Col>
                    </Grid>
                </Paper>
            </Box>
        </div>
    </div>
  );
}

export default StoreItemEdit;
